import { Pipe, PipeTransform } from '@angular/core';

const FORMAT_SUFFIXES = ['B', 'KB', 'MB', 'GB', 'TB'];

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  public transform(fileSizeInBytes, hideSpace: boolean = false, useDecimalAboveCentury = false, useDecimalWithGB = false) {
    if (fileSizeInBytes < 1024) return calc(fileSizeInBytes, useDecimalAboveCentury, false, false, 0);

    let index = 1;
    let bytesWeight = 1024;
    const formatSuffixesLength = FORMAT_SUFFIXES.length - 1;

    while (index < formatSuffixesLength) {
      if (fileSizeInBytes / bytesWeight < 1024) {
        break;
      }
      bytesWeight *= 1024;
      index++;
    }
    return calc(fileSizeInBytes / bytesWeight, useDecimalAboveCentury, hideSpace, useDecimalWithGB, index);
  }
}

function calc(calculation, useDecimalAboveCentury, hideSpace, useDecimalWithGB, index) {
  if (useDecimalAboveCentury && FORMAT_SUFFIXES[index + 1] && calculation > 100) {
    return (calculation / 1000).toFixed(1) + ' ' + FORMAT_SUFFIXES[index + 1];
  } else {
    if (useDecimalWithGB && FORMAT_SUFFIXES[index] === 'GB') {
      return Math.round(calculation).toFixed(1) + `${hideSpace ? '' : ' '}` + FORMAT_SUFFIXES[index];
    }

    return Math.round(calculation) + `${hideSpace ? '' : ' '}` + FORMAT_SUFFIXES[index];
  }
}
